module.exports = __webpack_public_path__ + "img/Tagline_todo preto.1eb51849.png";